import { put, take, takeLatest } from "redux-saga/effects";
import actionTypes from "../../actions/actionTypes";
import { push } from "connected-react-router";



function* chooseCinema({payload}) {
    try {
        const { cinemaId, path } = yield payload 

        yield put({
            type: actionTypes.PRINT_DATA_FILTER_REQUEST,
            payload: {
                cinemaId: cinemaId
            }
        })

        const filter = yield take([actionTypes.PRINT_DATA_FILTER_SUCCESS, actionTypes.PRINT_DATA_FILTER_ERROR])


        if(filter.type === actionTypes.PRINT_DATA_FILTER_SUCCESS) {
            yield put(push(path))
        } else {
            throw new Error('Could not filter print data')
        }
    } catch(e) {
        console.log('PRINT_TOOL_CHOOSE_CINEMA Error', e)
    }

}




function* watchChooseCinema() {
    yield takeLatest(actionTypes.PRINT_TOOL_CHOOSE_CINEMA, chooseCinema)
}

export default watchChooseCinema